import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import * as _ from "lodash";
import { Observable, from } from "rxjs";
import { Subject } from "rxjs";
import { SessionService } from "./session.service";

// The environment's default API base URL, captured once at module load so it is
// never lost when a client-specific override is applied at runtime.
const DEFAULT_API_BASE_URL = environment.apiBaseUrl;

@Injectable({
  providedIn: "root",
})
export class ApiService {
  public apiBaseUrl: any;
  executionUrl = "kpi/get-execution-details";
  triggerAction$ = new Subject<any>();

  trigger(value: any) {
    this.triggerAction$.next(value);
  }

  constructor(private httpClient: HttpClient) {
    this.apiBaseUrl = environment.apiBaseUrl;
    // Re-apply any client-specific override after a page reload, since the
    // selected client persists in sessionStorage but the URL override does not.
    this.setClientApiBaseUrl(this.getClientKey());
  }

  /**
   * Switches the API base URL based on the selected client_key. If the current
   * environment defines a URL for that client in `clientApiBaseUrls`, that URL
   * is used everywhere; otherwise it falls back to the environment default.
   * Works for any region (dev/stage/prod/prod2) because each environment file
   * carries its own per-client map.
   */
  setClientApiBaseUrl(clientKey: any) {
    const overrides: { [key: string]: string } =
      (environment as any).clientApiBaseUrls || {};
    const overrideUrl = clientKey != null ? overrides[clientKey] : "";
    const url = overrideUrl || DEFAULT_API_BASE_URL;

    this.apiBaseUrl = url;
    // Keep the ~80 components/services that read `environment.apiBaseUrl`
    // inline in sync (the object property is mutable even though the binding
    // is `const`).
    (environment as any).apiBaseUrl = url;
  }

  login(data: any) {
    return this.httpClient.post(this.apiBaseUrl + "/api/user-validation", data);
  }
  getuserName(data: any) {
    return this.httpClient.post(
      this.apiBaseUrl + "/api/validate-pwd-key",
      data
    );
  }

  forgotPassowrd(data: any) {
    const obj = {
      user_id: data,
    };
    return this.httpClient.post(
      this.apiBaseUrl + "/api/send-pwd-confirmation",
      obj
    );
  }
  userActivity(data: any) {
    return this.httpClient.post(
      this.apiBaseUrl + "/api/log-user-activity",
      data
    );
  }

  getCongnitoUserStatus(data: any) {
    return this.httpClient.post(
      this.apiBaseUrl + "/api/get-cognito-user-status",
      data
    );
  }
  getDoc(url: string): Observable<any> {
    return this.httpClient.get(`assets/json/${url}.json`);
  }

  getlogos(): Observable<any> {
    let endPoint: any = "api/get-logos";
    return this.get(endPoint);
  }

  get(url: string): Observable<any> {
    return this.httpClient.get(`${this.apiBaseUrl}/${url}`);
  }

  gets(url: string): Observable<any> {
    return this.httpClient.get(`${'https://dev-api.scraii.com'}/${url}`)
  }

  post(url: string, data: any): Observable<any> {
    // Employee key and Client key
    if (this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        client_key: this.getClientKey(),
        employee_key: this.getEmpKey(),
        module_key: this.getModuleKey(),
      };
      Object.assign(data, query);
    }

    return this.httpClient.post(`${this.apiBaseUrl}/${url}`, data);
  }

  posts(url: string, data: any): Observable<any> {

    // Employee key and Client key
    if(this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        "client_key": this.getClientKey(),
        "employee_key": this.getEmpKey()
      }
      Object.assign(data, query)
    }

    return this.httpClient.post(`${'https://dev-api.scraii.com'}/${url}`, data)
  }

  postBlob(url: string, data: any): Observable<any> {
    // Employee key and Client key
    if (this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        client_key: this.getClientKey(),
        employee_key: this.getEmpKey(),
        module_key: this.getModuleKey(),
      };
      Object.assign(data, query);
    }

    return this.httpClient.post(`${this.apiBaseUrl}/${url}`, data, {
      responseType: "blob",
    });
  }

  getEmpKey() {
    let emp: any = sessionStorage.getItem("employee_key");
    let employee_key = JSON.parse(emp);
    if (!employee_key) return false;
    return employee_key?._value;
  }

  getClientKey() {
    let client_key: any = sessionStorage.getItem("client");
    if (!client_key) return false;
    let value = JSON.parse(client_key);
    return value?.[0]?.client?.client_key || null;
  }

  getModuleKey() {
    let module: any = sessionStorage.getItem("module");
    if (!module) return "";
    let value = JSON.parse(module);
    return value?.module_key || "";
  }

  getBrandList(obj: any) {
    return this.httpClient.post(`${this.apiBaseUrl}/kpi/get-brand-filter`, obj);
  }

  alertKPIPost(url: string, data: any): Observable<any> {
    // Employee key and Client key
    if (this.getClientKey() && this.getEmpKey()) {
      let query: any = {
        client_key: this.getClientKey(),
        employee_key: this.getEmpKey(),
        module_key: this.getModuleKey(),
      };
      Object.assign(data, query);
    }

    return this.httpClient.post(`${this.apiBaseUrl}/${url}`, data);
  }

  alertKPIGet(url: string): Observable<any> {
    return this.httpClient.get(`${this.apiBaseUrl}/${url}`);
  }

  // New Calendar API
  //add and update event
  addEvent(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/update-events-data",
      data
    );
  }
  //get all Events
  getAllEvent(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/get-events-data",
      data
    );
  }
  //get all attendees
  getAllAttendees(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/get-event-attendees-data",
      data
    );
  }
  // delete event
  deleteEvent(data: any) {
    return this.httpClient.delete(
      environment.apiBaseUrl + "/api/events/delete-events-data",
      {
        body: data,
      }
    );
  }
  //update Attendees Status
  updateAttendeesStatus(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/events/update-attendee-status",
      data
    );
  }

  // Fix File endpoints
  getFixFileOutstandingErrors(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/api/fix-file/outstanding-errors/list`, data);
  }

  /**
   * Outstanding-error counts for the File Type chips beside the status tabs.
   * Returns a plain { <file type> : count } map, posted with the same query the
   * grid loads with.
   */
  getFixFileFieldCount(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/api/fix-file/outstanding-errors/field-count`, data);
  }

  getFixFileGridColumns(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/api/fix-file/grid-columns`, data);
  }

  getFixFileErrorByKey(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/api/fix-file/outstanding-errors/get-by-key`, data);
  }

  saveFixFileOutstandingErrors(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/api/fix-file/outstanding-errors/save`, data);
  }

  getFixFileChangeAudit(data: any): Observable<any> {
    return this.httpClient.post(`${this.apiBaseUrl}/api/fix-file/change-audit/list`, data);
  }

  // AI chat history endpoints
  /**
   * The assistant's chat_history rows with their usage / cost detail — what the
   * SQL Cache Review screen reads. Posted as-is: the body is the caller's
   * request context (client_key, employee_key, module_key, user_id, …) plus any
   * scoping fields it wants applied server-side.
   */
  getChatHistoryUsageDetail(data: any): Observable<any> {
    return this.httpClient.post(
      `${this.apiBaseUrl}/api/chat-history/usage/get-detail`,
      data
    );
  }

  // PHI Verification Code
  sendPhiVerificationCode(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/send-phi-verification-code",
      data,
      { responseType: "text" }
    );
  }

  scheduleVideoMeeting(data: any) {
    return this.httpClient.post(environment.apiBaseUrl + "/api/meetings/schedule", data);
  }

  resolveGuestMeeting(data: any) {
    return this.httpClient.post(environment.apiBaseUrl + "/api/meetings/guest/resolve", data);
  }

  joinGuestMeeting(data: any) {
    return this.httpClient.post(environment.apiBaseUrl + "/api/meetings/guest/join", data);
  }

  appendMeetingTranscript(data: {
    publicCode: string;
    resultId: string;
    speakerExternalUserId: string;
    text: string;
    startTimeMs: number;
  }) {
    return this.httpClient.post(environment.apiBaseUrl + "/api/meetings/transcript", data);
  }

  listMeetingParticipants(publicCode: string, externalUserIds: string[]) {
    return this.httpClient.post<{ externalUserId: string; displayName: string }[]>(
      environment.apiBaseUrl + "/api/meetings/participants",
      { publicCode, externalUserIds }
    );
  }

  listMeetingTranscript(publicCode: string) {
    return this.httpClient.post<any[]>(environment.apiBaseUrl + "/api/meetings/transcript/list", { publicCode });
  }

  /** Host: end the meeting, build an AI summary from the transcript, and email participants. */
  endMeetingWithSummary(publicCode: string) {
    return this.httpClient.post<{
      publicCode?: string;
      status?: string;
      summary?: string;
      emailedCount?: number;
      message?: string;
      data?: {
        publicCode?: string;
        status?: string;
        summary?: string;
        emailedCount?: number;
        message?: string;
      };
    }>(environment.apiBaseUrl + "/api/meetings/end-with-summary", { publicCode });
  }

  startPhoneCall(data: any) {
    return this.httpClient.post(environment.apiBaseUrl + "/api/meetings/calls/start", data);
  }

  phoneCallStatus(data: any) {
    return this.httpClient.post(environment.apiBaseUrl + "/api/meetings/calls/status", data);
  }

  hangupPhoneCall(data: any) {
    return this.httpClient.post(environment.apiBaseUrl + "/api/meetings/calls/hangup", data);
  }

  listVisits(data: { fromUtc: string; toUtc: string }) {
    return this.httpClient.post<any[]>(environment.apiBaseUrl + "/api/visits/list", data);
  }

  getVisit(visitKey: number) {
    return this.httpClient.post<any>(environment.apiBaseUrl + "/api/visits/get", { visitKey });
  }

  createVisit(data: any) {
    return this.httpClient.post<any>(environment.apiBaseUrl + "/api/visits/create", data);
  }

  updateVisit(data: any) {
    return this.httpClient.post<any>(environment.apiBaseUrl + "/api/visits/update", data);
  }

  cancelVisit(visitKey: number) {
    return this.httpClient.post<any>(environment.apiBaseUrl + "/api/visits/cancel", { visitKey });
  }

  resendVisit(visitKey: number) {
    return this.httpClient.post<any>(environment.apiBaseUrl + "/api/visits/resend", { visitKey });
  }

  // Verify PHI Verification Code
  verifyPhiVerificationCode(data: any) {
    return this.httpClient.post(
      environment.apiBaseUrl + "/api/verify-phi-verification-code",
      data,
      { responseType: "text" }
    );
  }
}
